module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_100000_250000.79273aac.png";